<template lang="pug">
  window(:title="$t('about_hscmap')", :isOpen="module.show", :closeButton="true", @closebuttonclick="module.show = false", positionHint="center")
    dl
      dt Build Target:
      dd {{buildTarget}}
      dt Build Mode:
      dd {{mode}}
      dt Revision:
      dd {{revision}}
    .center
      button(@click="reset") {{$t('reset_all')}}
</template>


<i18n>
en:
  about_hscmap: About hscMap
  reset_all: Reset All Settings
ja:
  about_hscmap: hscMapについて
  reset_all: 全ての設定をリセット
</i18n>


<script lang="ts">
import Vue from 'vue'
import { store } from '@/store';
export default Vue.extend({
  props: {
    module: { required: true },
  },
  computed: {
    buildTarget() {
      return process.env.NODE_ENV
    },
    revision() {
      return process.env.REVISION
    },
    mode() {
      return process.env.VUE_APP_DATASET
    },
  },
  methods: {
    reset() {
      if (confirm(`Are you sure to clear all settings for hscMap?`)) {
        store.reset()
      }
    },
  },
})
</script>


<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: center;
}
</style>
